export default "__VITE_ASSET__LVm2hrSm__"